(function () {
  'use strict';
  var root = document.getElementById('concentrations');
  if (!root || root.getAttribute('data-cp-ready') === '1') return;
  var D;
  try { D = JSON.parse(document.getElementById('cp-data').textContent); } catch (e) { return; }
  root.setAttribute('data-cp-ready', '1');

  var FKEY = 'eai-cp-filters', PKEY = 'eai-plan', MAX = 3, MAXF = 2, PREVIEW = 3;
  var HIDE = ['level', 'time', 'goal', 'learn', 'budget'];
  var ROLE = { start: 'Start here', foundation: 'Foundation', focus: 'Focus' };
  function q(s, el) { return (el || root).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { s = String(s || '').toLowerCase(); if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); return s.replace(/[‘’]/g, "'"); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function title(code) { var c = D.courses[code]; return c ? c[0] : code; }
  function isOpen(code) { var c = D.courses[code]; return !!(c && c[1]); }
  function chip(code) { return isOpen(code) ? '<span class="cp-st cp-st-open">Open now</span>' : '<span class="cp-st cp-st-soon">Opening soon</span>'; }
  function tname(id) { var t = D.teachers[id]; return t ? t.n + (t.look ? ' (look ' + t.look + ')' : '') : id; }
  function inList(a, v) { return !!a && a.indexOf(v) >= 0; }
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); return window.localStorage.getItem(k) === v; } catch (e) { return false; } },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  };

  var G = {};
  D.needs.forEach(function (g) { G[g.id] = g; g.map = {}; g.opts.forEach(function (o) { g.map[o[0]] = o[1]; }); });
  function emptyNeeds() { var o = {}; D.needs.forEach(function (g) { o[g.id] = []; }); return o; }

  var schools = {}, items = [], byId = {};
  D.schools.forEach(function (s) { schools[s.id] = s; });
  (D.undeclared ? [D.undeclared] : []).concat(D.items).forEach(function (it) {
    it.li = q('.cp-item[data-id="' + it.id + '"]');
    it.sch = it.school ? schools[it.school] : null;
    it.hay = norm([it.name, it.summary, it.who, it.sch ? it.sch.name : 'undeclared explore not sure yet', it.m ? 'model program ' + it.m.name : ''].join(' '));
    items.push(it); byId[it.id] = it;
  });

  var input = q('#cp-q'), clearBtn = q('.cp-clear'), chipBox = q('.cp-chips'), chipBar = q('.cp-chipbar');
  var chips = qa('.cp-chip'), groups = qa('.cp-group');
  var countEl = q('.cp-count'), liveNow = q('.cp-live-now');
  var empty = q('.cp-empty'), emptyText = q('.cp-empty-text'), und = q('.cp-und');
  var tray = q('.cp-tray'), trayList = q('.cp-tray-list'), trayCount = q('.cp-tray-count'), trayMsg = q('.cp-tray-msg'), cmpBtn = q('[data-cp-compare]');
  var needsToggle = q('.cp-needs-toggle'), needsPanel = q('#cp-needs-panel'), needsBadge = q('.cp-needs-badge'), doneBtn = q('[data-cp-done]');
  var activeBox = q('.cp-active'), activeList = q('.cp-active-list');
  var pageSlot = q('.cp-plan-slot[data-ctx="page"]');
  var dlg = q('#cp-detail'), dTitle = q('#cp-d-title'), dSchool = q('#cp-d-school'), dBody = q('#cp-d-body');
  var cdlg = q('#cp-compare'), cTitle = q('#cp-c-title'), cBody = q('#cp-c-body');
  var state = { school: 'all', query: '', needs: emptyNeeds() }, pins = [], current = null, liveTimer = 0;
  var plan = { c: null, f: [] };
  var opts = qa('.cp-opt input').map(function (inp) {
    var l = inp.closest('.cp-opt');
    return { inp: inp, g: inp.getAttribute('data-g'), v: inp.value, label: l, n: q('.cp-opt-n', l), nv: q('.cp-opt-nv', l) };
  });

  qa('[data-cp-js]').forEach(function (el) { el.hidden = false; });

  /* ---------- filters ---------- */
  function say(msg) { liveNow.textContent = ''; setTimeout(function () { liveNow.textContent = msg; }, 40); }
  function setCount(msg, now) {
    clearTimeout(liveTimer);
    if (now) countEl.textContent = msg; else liveTimer = setTimeout(function () { countEl.textContent = msg; }, 400);
  }
  function hidingActive() { return HIDE.some(function (g) { return state.needs[g].length > 0; }); }
  function anyNeeds() { return D.needs.some(function (g) { return state.needs[g.id].length > 0; }); }
  function selCount() { var n = 0; D.needs.forEach(function (g) { n += state.needs[g.id].length; }); return n; }
  function baseOk(it, toks) {
    var inSchool = it.school ? (state.school === 'all' || it.school === state.school) : state.school === 'all';
    return inSchool && toks.every(function (t) { return it.hay.indexOf(t) !== -1; });
  }
  function needOk(it, skip) {
    for (var i = 0; i < HIDE.length; i++) {
      var g = HIDE[i], sel = state.needs[g], have = it.nd[g] || [];
      if (g === skip || !sel.length) continue;
      if (!sel.some(function (v) { return have.indexOf(v) >= 0; })) return false;
    }
    return true;
  }
  function features(short) {
    var f = [];
    state.needs.support.forEach(function (s) { (D.support[s] || []).forEach(function (k) { if (f.indexOf(k) < 0) f.push(k); }); });
    return f.map(function (k) { return D.features[k][short ? 1 : 0]; });
  }
  function facets(toks) {
    var base = items.filter(function (it) { return baseOk(it, toks); });
    opts.forEach(function (o) {
      if (o.g === 'support') return;
      var c = 0;
      base.forEach(function (it) { if (needOk(it, o.g) && inList(it.nd[o.g], o.v)) c++; });
      o.n.textContent = c; o.nv.textContent = ', ' + plural(c, 'path', 'paths');
      o.label.classList.toggle('cp-zero', c === 0);
    });
  }
  function countText(n, toks) {
    var sch = state.school !== 'all' ? schools[state.school] : null, qt = state.query.trim(), na = hidingActive(), total = items.length, txt, parts = [];
    if (!sch && !qt && !na) txt = total + ' learning paths: ' + (total - 1) + ' concentrations in ' + D.schools.length + ' schools, plus Undeclared.';
    else if (!qt && !na) txt = plural(n, 'learning path', 'learning paths') + ' in the ' + sch.name + '.';
    else {
      if (na) parts.push('your needs');
      if (qt) parts.push('“' + qt + '”');
      txt = (n ? n + ' of ' + total + ' learning paths match ' : 'No learning paths match ') + parts.join(' and ') + (sch ? ' in the ' + sch.name : '') + '.';
    }
    if (state.needs.support.length) txt += ' Support needs keep every path: they are features of the course player.';
    return txt;
  }
  function renderActive() {
    var list = [], qt = state.query.trim();
    if (qt) list.push({ k: 'q', g: 'Search', l: '“' + qt + '”' });
    if (state.school !== 'all') list.push({ k: 'school', g: 'School', l: schools[state.school].short });
    D.needs.forEach(function (g) { state.needs[g.id].forEach(function (v) { list.push({ k: g.id + ':' + v, g: g.label, l: g.map[v] }); }); });
    activeBox.hidden = !list.length;
    activeList.innerHTML = list.map(function (x) {
      return '<li><button type="button" class="cp-af" data-cp-af="' + esc(x.k) + '"><span class="cp-vh">Remove filter, ' + esc(x.g) + ': </span><span>' + esc(x.l) + '</span><span class="cp-x" aria-hidden="true">×</span></button></li>';
    }).join('');
  }
  function saveFilters() {
    if (state.school !== 'all' || anyNeeds()) store.set(FKEY, JSON.stringify({ v: 1, school: state.school, needs: state.needs }));
    else store.del(FKEY);
  }
  function loadFilters() {
    var raw = store.get(FKEY), o = null;
    if (!raw) return;
    try { o = JSON.parse(raw); } catch (e) { return; }
    if (!o || typeof o !== 'object') return;
    if (o.school && schools[o.school]) state.school = o.school;
    if (o.needs && typeof o.needs === 'object') D.needs.forEach(function (g) {
      var a = o.needs[g.id];
      if (Array.isArray(a)) state.needs[g.id] = g.opts.map(function (x) { return x[0]; }).filter(function (v) { return a.indexOf(v) >= 0; });
    });
  }

  function apply(mode) {
    var toks = norm(state.query).split(/\s+/).filter(Boolean), n = 0, na = hidingActive();
    items.forEach(function (it) { var ok = baseOk(it, toks) && needOk(it, null); if (it.li) it.li.hidden = !ok; if (ok) n++; });
    if (und) und.hidden = !und.querySelector('.cp-item:not([hidden])');
    var preview = state.school === 'all' && !toks.length && !na;
    groups.forEach(function (g) {
      var s = schools[g.getAttribute('data-school')], lis = qa('.cp-item', g);
      var shown = lis.filter(function (li) { return !li.hidden; }), open = g.getAttribute('data-cp-expanded') === '1';
      var can = preview && shown.length > PREVIEW, fold = can && !open;
      lis.forEach(function (li) { li.classList.toggle('cp-folded', fold && shown.indexOf(li) >= PREVIEW); });
      g.hidden = shown.length === 0;
      var c = q('.cp-group-count', g), mw = q('.cp-group-more', g), mb = mw && q('[data-cp-more]', mw);
      if (c && s) c.textContent = (toks.length || na) ? (shown.length + ' of ' + plural(s.n, 'path', 'paths') + ' match') : plural(s.n, 'path', 'paths');
      if (mw) {
        mw.hidden = !can;
        if (can) {
          mb.setAttribute('aria-expanded', open ? 'true' : 'false');
          q('.cp-more-label', mb).textContent = open ? 'Show fewer ' + s.short + ' paths' : 'Show all ' + shown.length + ' ' + s.short + ' paths';
        }
      }
    });
    facets(toks);
    var sup = features(true), supTxt = sup.length ? sup.join(', ') : '';
    qa('.cp-card-sup').forEach(function (p) { p.hidden = !supTxt; p.innerHTML = supTxt ? '<b>Supports you with:</b> ' + esc(supTxt) + '.' : ''; });
    renderActive();
    var k = selCount();
    needsBadge.hidden = !k; needsBadge.textContent = k + ' selected';
    doneBtn.textContent = n ? 'Show ' + plural(n, 'matching path', 'matching paths') : 'No paths match yet';
    var txt = countText(n, toks);
    empty.hidden = n !== 0;
    if (!n) emptyText.textContent = na
      ? 'No path matches every need you picked' + (state.query.trim() ? ' and “' + state.query.trim() + '”' : '') + (state.school !== 'all' ? ' in the ' + schools[state.school].name : '') + '. Remove a filter above, or clear them all.'
      : 'Nothing matches “' + state.query.trim() + '”' + (state.school !== 'all' ? ' in the ' + schools[state.school].name : '') + '. Try a broader word, such as “health”, “design” or “business”, or look through every path.';
    setCount(txt, mode !== 'typing');
    if (mode !== 'init') saveFilters();
  }

  function syncSchool(focus) {
    chips.forEach(function (c) {
      var on = c.getAttribute('data-school') === state.school;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
      if (on && focus) c.focus();
    });
  }
  function syncOpts() { opts.forEach(function (o) { o.inp.checked = inList(state.needs[o.g], o.v); }); }
  function setSchool(id, focus) { state.school = id; syncSchool(focus); apply('now'); }
  chipBox.addEventListener('click', function (e) { var c = e.target.closest('.cp-chip'); if (c) setSchool(c.getAttribute('data-school'), false); });
  chipBox.addEventListener('keydown', function (e) {
    var i = chips.indexOf(document.activeElement), k = e.key, j = -1;
    if (i < 0) return;
    if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % chips.length;
    else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + chips.length) % chips.length;
    else if (k === 'Home') j = 0;
    else if (k === 'End') j = chips.length - 1;
    if (j < 0) return;
    e.preventDefault();
    setSchool(chips[j].getAttribute('data-school'), true);
  });
  function edges() {
    var max = chipBox.scrollWidth - chipBox.clientWidth;
    chipBar.classList.toggle('cp-more-right', max > 2 && chipBox.scrollLeft < max - 2);
    chipBar.classList.toggle('cp-more-left', chipBox.scrollLeft > 2);
  }
  chipBox.addEventListener('scroll', edges);
  window.addEventListener('resize', edges);

  function setQuery(v, mode) { input.value = v; state.query = v; clearBtn.hidden = !v; apply(mode); }
  input.addEventListener('input', function () { state.query = input.value; clearBtn.hidden = !input.value; apply('typing'); });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && input.value) { e.preventDefault(); setQuery('', 'now'); } });
  clearBtn.addEventListener('click', function () { setQuery('', 'now'); input.focus(); });

  needsPanel.addEventListener('change', function (e) {
    var t = e.target, g = t && t.getAttribute && t.getAttribute('data-g');
    if (!g) return;
    state.needs[g] = opts.filter(function (o) { return o.g === g && o.inp.checked; }).map(function (o) { return o.v; });
    apply('now');
  });
  function setPanel(open) { needsToggle.setAttribute('aria-expanded', open ? 'true' : 'false'); needsPanel.hidden = !open; }
  needsToggle.addEventListener('click', function () { setPanel(needsToggle.getAttribute('aria-expanded') !== 'true'); });
  doneBtn.addEventListener('click', function () { setPanel(false); if (countEl.scrollIntoView) countEl.scrollIntoView({ block: 'start' }); countEl.focus(); });
  function clearAll() {
    state.query = ''; input.value = ''; clearBtn.hidden = true;
    state.school = 'all'; syncSchool(false);
    state.needs = emptyNeeds(); syncOpts();
    apply('now');
    say('All filters cleared.');
  }
  activeBox.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-cp-clear-all')) { clearAll(); needsToggle.focus(); return; }
    var key = b.getAttribute('data-cp-af');
    if (!key) return;
    var idx = qa('[data-cp-af]', activeList).indexOf(b);
    if (key === 'q') { input.value = ''; state.query = ''; clearBtn.hidden = true; }
    else if (key === 'school') { state.school = 'all'; syncSchool(false); }
    else { var g = key.slice(0, key.indexOf(':')), v = key.slice(key.indexOf(':') + 1); state.needs[g] = state.needs[g].filter(function (x) { return x !== v; }); syncOpts(); }
    apply('now');
    var left = qa('[data-cp-af]', activeList);
    if (left.length) left[Math.min(idx, left.length - 1)].focus(); else needsToggle.focus();
  });

  /* ---------- compare pins ---------- */
  function trayNote(msg) { trayMsg.textContent = msg; say(msg); }
  function togglePin(id) {
    var it = byId[id], k = pins.indexOf(id);
    if (!it) return;
    if (k >= 0) { pins.splice(k, 1); trayNote(it.name + ' removed from compare.'); }
    else if (pins.length >= MAX) { trayNote('You can compare up to three paths. Remove one to add ' + it.name + '.'); }
    else { pins.push(id); trayNote(it.name + ' added to compare.' + (pins.length < 2 ? ' Pin one more to compare.' : '')); }
    syncPins();
  }
  function syncPins() {
    qa('[data-cp-pin]').forEach(function (b) {
      var on = pins.indexOf(b.getAttribute('data-cp-pin')) >= 0, card = b.closest('.cp-card');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (card) card.classList.toggle('cp-pinned', on);
    });
    tray.hidden = pins.length === 0;
    trayCount.textContent = pins.length + ' of ' + MAX + ' pinned';
    trayList.innerHTML = pins.map(function (id) {
      return '<li><button type="button" class="cp-tag" data-cp-unpin="' + esc(id) + '"><span>' + esc(byId[id].name) + '</span><span class="cp-x" aria-hidden="true">×</span><span class="cp-vh">, remove from compare</span></button></li>';
    }).join('');
    cmpBtn.setAttribute('aria-disabled', pins.length < 2 ? 'true' : 'false');
  }
  function home() { countEl.focus(); }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button, a');
    if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-cp-open')) openDetail(b.getAttribute('data-cp-open'), b);
    else if (b.hasAttribute('data-cp-pin')) togglePin(b.getAttribute('data-cp-pin'));
    else if (b.hasAttribute('data-cp-unpin')) {
      var id = b.getAttribute('data-cp-unpin'), inCmp = cdlg.contains(b);
      togglePin(id);
      if (inCmp) { renderCompare(); cTitle.focus(); return; }
      var next = q('[data-cp-unpin]', tray);
      if (next) next.focus(); else if (!tray.hidden) cmpBtn.focus();
      else { var it = byId[id], pb = it && it.li && !it.li.hidden && q('[data-cp-pin]', it.li); if (pb) pb.focus(); else home(); }
    }
    else if (b.hasAttribute('data-cp-compare')) {
      if (pins.length < 2) { trayNote('Pin at least two paths to compare them side by side.'); return; }
      renderCompare(); showDlg(cdlg, b); cTitle.focus();
    }
    else if (b.hasAttribute('data-cp-clear')) { pins = []; syncPins(); trayMsg.textContent = ''; say('Compare list cleared.'); home(); }
    else if (b.hasAttribute('data-cp-detail')) openDetail(b.getAttribute('data-cp-detail'), b);
    else if (b.hasAttribute('data-cp-more')) {
      var g = b.closest('.cp-group'), opening = g.getAttribute('data-cp-expanded') !== '1';
      g.setAttribute('data-cp-expanded', opening ? '1' : '0');
      apply('silent');
      var vis = qa('.cp-item:not([hidden])', g);
      if (opening && vis[PREVIEW]) q('.cp-open', vis[PREVIEW]).focus();
      else if (b.scrollIntoView) b.scrollIntoView({ block: 'nearest' });
      say(opening ? 'Showing all ' + vis.length + ' paths in the ' + schools[g.getAttribute('data-school')].name + '.' : 'Showing the first ' + PREVIEW + ' paths.');
    }
    else if (b.hasAttribute('data-cp-reset')) { clearAll(); input.focus(); }
    else if (b.hasAttribute('data-cp-declare')) declare(b.getAttribute('data-cp-declare'));
    else if (b.hasAttribute('data-cp-focus')) toggleFocus(b.getAttribute('data-cp-focus'));
    else if (b.hasAttribute('data-cp-plan-rm')) removeFromPlan(b);
    else if (b.hasAttribute('data-cp-plan-save')) savePlan(b);
    else if (b.hasAttribute('data-cp-adv')) { if (dlg.open || cdlg.open) { e.preventDefault(); goTo(D.links.advanced); } }
    else if (b.hasAttribute('data-cp-ask')) { e.preventDefault(); ask(current); }
  });

  /* ---------- dialogs ---------- */
  function lock() { document.documentElement.classList.add('cp-lock'); }
  function showDlg(d, opener) {
    d._opener = opener || document.activeElement; d._skip = false;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
    else { d.setAttribute('open', ''); d.classList.add('cp-fallback'); }
    lock();
  }
  function hideDlg(d, skip) {
    d._skip = !!skip;
    if (typeof d.close === 'function') { if (d.open) d.close(); }
    else if (d.hasAttribute('open')) { d.removeAttribute('open'); afterClose.call(d); }
  }
  function afterClose() {
    var d = this, o = d._opener;
    if (!dlg.open && !cdlg.open) document.documentElement.classList.remove('cp-lock');
    d._opener = null;
    if (d === dlg) current = null;
    if (!d._skip && o && document.documentElement.contains(o) && o.focus) o.focus();
  }
  function focusables(d) {
    return qa('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', d)
      .filter(function (el) { return el.getClientRects().length && !el.closest('[hidden]'); });
  }
  [dlg, cdlg].forEach(function (d) {
    var downOnBackdrop = false;
    d.addEventListener('close', afterClose);
    d.addEventListener('mousedown', function (e) { downOnBackdrop = e.target === d; });
    d.addEventListener('click', function (e) { if (e.target === d && downOnBackdrop) hideDlg(d); downOnBackdrop = false; });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && typeof d.showModal !== 'function') { e.preventDefault(); hideDlg(d); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(d), a = document.activeElement;
      if (!f.length) return;
      if (e.shiftKey && (a === f[0] || f.indexOf(a) === -1)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    q('[data-cp-close]', d).addEventListener('click', function () { hideDlg(d); });
  });
  function goTo(href) {
    if (dlg.open) hideDlg(dlg, true);
    if (cdlg.open) hideDlg(cdlg, true);
    if (href.charAt(0) === '#') {
      var t = document.getElementById(href.slice(1));
      if (location.hash === href) { if (t && t.scrollIntoView) t.scrollIntoView(); } else location.hash = href;
    } else location.href = href;
  }

  function pathRow(e, i, core) {
    var open = isOpen(e.c), notes = [];
    if (e.n && e.n.length) notes.push('Needs ' + e.n.join(' and ') + ' first');
    if (e.a && e.a.length) notes.push('Take alongside ' + e.a.join(' and '));
    return '<li class="cp-step' + (open ? ' is-open' : '') + '">' +
      (core ? '<span class="cp-num" aria-hidden="true">' + (i + 1) + '</span>' : '<span class="cp-mark" aria-hidden="true"><span class="cp-dot"></span></span>') +
      '<div class="cp-step-main"><p class="cp-step-top"><span class="cp-code">' + esc(e.c) + '</span>' +
      (core && e.r ? '<span class="cp-role">' + esc(ROLE[e.r] || e.r) + '</span>' : '') + chip(e.c) + '</p>' +
      '<p class="cp-step-title">' + esc(e.t || title(e.c)) + '</p>' +
      (notes.length ? '<p class="cp-step-note">' + esc(notes.join(' · ')) + '</p>' : '') + '</div></li>';
  }
  function cardParts(s) { var k = s.indexOf(' · '); return k < 0 ? [s, ''] : [s.slice(0, k), s.slice(k + 3)]; }
  function videoTeachers(it) { return it.t.filter(function (id) { return D.teachers[id] && D.teachers[id].v; }).map(function (id) { return D.teachers[id].n; }).filter(function (n, i, a) { return a.indexOf(n) === i; }); }

  function fitHTML(it) {
    var rows = HIDE.map(function (g) {
      var vals = (it.nd[g] || []).map(function (v) {
        var hit = inList(state.needs[g], v), l = esc(G[g].map[v]);
        return hit ? '<span class="cp-hit">' + l + '<span class="cp-vh"> (you picked this)</span></span>' : l;
      });
      var extra = '';
      if (g === 'learn' && inList(it.nd.learn, 'video')) { var vt = videoTeachers(it); if (vt.length) extra = ' (video lessons now from ' + esc(vt.join(' and ')) + ')'; }
      return '<div><dt>' + esc(G[g].label) + '</dt><dd>' + vals.join(', ') + extra + '</dd></div>';
    }).join('');
    var sup = features(false);
    var supLine = sup.length
      ? '<p class="cp-sup"><b>Supports you with:</b> ' + esc(sup.join(', ')) + '. Features of the course player that can help, on every path; they don’t promise a particular result.</p>'
      : '<p class="cp-sup"><b>On every path:</b> captions and transcripts, read-aloud, reading themes, text size, focus mode, Extended or Flexible pace, no timed tests, unlimited quiz tries and keyboard access.</p>';
    return '<div class="cp-fit"><h4 class="cp-h">How it fits your needs</h4><dl>' + rows + '</dl>' + supLine + '</div>';
  }

  function modelHTML(it) {
    var m = it.m;
    if (!it.school) return '';
    if (!m) return '<div class="cp-model"><h4 class="cp-model-h">In the Advanced Program</h4><p>' + esc(D.advanced.notbuilt) + '</p><p class="cp-fine">' + esc(D.advanced.fine) + '</p><a class="cp-btn-text" href="' + esc(D.advanced.href) + '" data-cp-adv>' + esc(D.advanced.label) + '</a></div>';
    var h = '<div class="cp-model"><h4 class="cp-model-h">Model program: ' + esc(m.name) + '</h4>' +
      '<p>' + (m.x ? 'The Advanced Program is built in full for this concentration, as one of the six models other fields copy.' : 'The closest model program to this path is ' + esc(m.name) + ', built in full in the Advanced Program.') +
      ' Its Certificate of Completion reads “' + esc(m.declared) + '”.</p>';
    if (m.ai) h += '<p>' + esc(m.ai) + '</p>';
    h += '<ol class="cp-terms">' + m.terms.map(function (t) {
      return '<li class="cp-term"><p class="cp-term-h"><b>' + esc(t.t) + (t.s ? ' · shared core' : '') + '</b>' + esc(t.n) + '</p><ul>' + t.c.map(function (c) {
        return '<li><b>' + esc(c[0]) + '</b>' + esc(c[1] || 'Shared core course') + '</li>';
      }).join('') + '</ul></li>';
    }).join('') + '</ol>';
    if (m.cap) h += '<p><b>Capstone:</b> ' + esc(m.cap) + '</p>';
    if (m.focus && m.focus.length) h += '<p><b>As a Focus:</b> ' + esc(m.focus.map(function (c) { return c[0] + ' ' + c[1]; }).join(' · ')) + ', plus a Focus Reading Pack.</p>';
    if (m.lic) h += '<p class="cp-lic">' + esc(m.lic) + '</p>';
    h += '<p class="cp-fine">' + esc(D.advanced.fine) + ' ' + esc(D.advanced.how) + '</p>' +
      '<a class="cp-btn-text" href="' + esc(D.advanced.href) + '" data-cp-adv>' + esc(D.advanced.label) + '</a></div>';
    return h;
  }

  function declareHTML(it) {
    if (!it.school) return '<div class="cp-declare"><h4 class="cp-dec-h">Declare when you’re ready</h4><p class="cp-fine">Undeclared isn’t something you declare. Start with the open courses, then declare a concentration when a subject pulls you in.</p><p class="cp-dec-honest">' + esc(D.planHonest) + '</p><div class="cp-plan-slot" data-ctx="detail"></div></div>';
    return '<div class="cp-declare"><h4 class="cp-dec-h">Declare your plan</h4>' +
      '<div class="cp-dec-btns"><button type="button" class="cp-btn cp-btn-block cp-btn-cta" data-cp-declare="' + esc(it.id) + '">Declare this concentration</button>' +
      '<button type="button" class="cp-btn cp-btn-block" data-cp-focus="' + esc(it.id) + '">Add as a Focus</button></div>' +
      '<p class="cp-dec-hint"></p>' +
      '<p class="cp-dec-honest">' + esc(D.planHonest) + '</p>' +
      '<p class="cp-fine">' + esc(D.focusText) + '</p>' +
      '<p class="cp-dec-msg" role="status" aria-live="polite"></p>' +
      '<div class="cp-plan-slot" data-ctx="detail"></div></div>';
  }

  function detailHTML(it) {
    var off = D.offers[it.offer], openN = it.core.filter(function (e) { return isOpen(e.c); }).length;
    var h = '<div class="cp-d-grid"><div class="cp-d-intro"><p class="cp-d-lead">' + esc(it.summary) + '</p>' +
      '<div class="cp-d-for"><h4 class="cp-h">Who it’s for</h4><p>' + esc(it.who) + '</p></div>' + fitHTML(it) + '</div>';
    h += '<aside class="cp-d-aside" aria-label="Start and declare this path"><dl class="cp-glance">' +
      '<div><dt>Starts with</dt><dd>' + esc(it.starts) + '</dd></div>' +
      '<div><dt>Status</dt><dd>Open now</dd></div>' +
      '<div><dt>Length</dt><dd>' + esc(it.len) + ', self-paced</dd></div>' +
      '<div><dt>Core courses</dt><dd>' + it.core.length + ' (' + openN + ' open now)</dd></div>' +
      '<div><dt>Electives</dt><dd>' + it.el.length + ' that fit</dd></div>' +
      (it.m ? '<div><dt>Advanced Program</dt><dd>Model program</dd></div>' : '') + '</dl>' +
      '<p class="cp-fine">' + esc(D.lengthNote) + '</p>';
    h += '<div class="cp-actions"><a class="cp-btn cp-btn-cta cp-btn-block" href="' + esc(off.href) + '" data-cp-start>' + esc(off.label) + '</a>' +
      '<p class="cp-fine">' + esc(off.fine) + '</p>';
    if (it.offer === 'bundle') h += '<p class="cp-also">Or one at a time: <a class="cp-btn-text" href="' + esc(D.offers.a101.href) + '">A101, $49</a><a class="cp-btn-text" href="' + esc(D.offers.point.href) + '">The Point, $49</a></p>';
    h += '<a class="cp-btn cp-btn-block" href="' + esc(D.program.href) + '">' + esc(D.program.label) + '</a><p class="cp-fine">' + esc(D.program.fine) + '</p>' +
      '<div class="cp-pair"><a class="cp-btn" href="' + esc(D.links.contact) + '" data-cp-ask>Ask Aurelia</a>' +
      '<button type="button" class="cp-pin" data-cp-pin="' + esc(it.id) + '" aria-pressed="false"><span class="cp-box" aria-hidden="true"></span>Compare</button></div></div>';
    h += declareHTML(it);
    h += '<h4 class="cp-h">Suggested teachers</h4><ul class="cp-teachers">' + it.t.map(function (id) {
      var t = D.teachers[id]; if (!t) return '';
      return '<li><img src="' + t.p + '" alt="" width="56" height="75" loading="lazy" decoding="async"><span><span class="cp-t-name">' + esc(tname(id)) + '</span>' +
        '<span class="cp-t-mode">' + (t.v ? 'Video lessons now' : 'Teaches with the device voice') + '</span><span class="cp-t-try">' + esc(t['try']) + '</span></span></li>';
    }).join('') + '</ul><p class="cp-fine">' + esc(D.teacherNote) + '</p></aside>';
    h += '<div class="cp-d-path"><h4 class="cp-h">The path, in order</h4>' +
      '<p class="cp-fine cp-legend">Start here: open now. Foundation: needed before or alongside a later course. Focus: gives the path its subject.</p>' +
      '<ol class="cp-steps">' + it.core.map(function (e, i) { return pathRow(e, i, true); }).join('') + '</ol>';
    if (it.el.length) h += '<h4 class="cp-h">Electives that fit</h4><ul class="cp-steps">' + it.el.map(function (e, i) { return pathRow(e, i, false); }).join('') + '</ul>';
    h += modelHTML(it);
    h += '<h4 class="cp-h">Skill cards that suit it</h4>';
    h += it.cards.length ? '<ul class="cp-skills">' + it.cards.map(function (s) { var p = cardParts(s); return '<li><strong>' + esc(p[0]) + '</strong>' + (p[1] ? '<span>' + esc(p[1]) + '</span>' : '') + '</li>'; }).join('') + '</ul>'
      : '<p class="cp-fine">No skill card is suggested for this path yet.</p>';
    h += '<p class="cp-fine">' + esc(D.cardsNote) + '</p><a class="cp-btn-text" href="' + esc(D.links.cards) + '">Browse skill cards at lundr.tech</a>';
    if (it.sch) h += '<div class="cp-about"><h4 class="cp-h">About the ' + esc(it.sch.name) + '</h4><p>' + esc(it.sch.summary) + '</p></div>';
    h += '<div class="cp-d-note"><p>' + esc(D.note) + '</p><p>' + esc(D.fine) + '</p></div></div></div>';
    return h;
  }

  function openDetail(id, opener) {
    var it = byId[id]; if (!it) return;
    current = id;
    dSchool.textContent = it.sch ? it.sch.name : 'Not sure yet?';
    dTitle.textContent = it.name;
    dBody.innerHTML = detailHTML(it);
    dBody.scrollTop = 0;
    syncPins();
    syncDeclare();
    showDlg(dlg, opener);
    dTitle.focus();
  }

  function ask(id) {
    var A = window.EAIAdvisor;
    hideDlg(dlg, true); if (cdlg.open) hideDlg(cdlg, true);
    if (A && typeof A.open === 'function') { try { A.open('concentration:' + id); return; } catch (err) {} }
    goTo(D.links.contact || '#contact');
  }

  /* ---------- declare + focus + plan ---------- */
  function loadPlan() {
    var raw = store.get(PKEY), o = null;
    if (raw) { try { o = JSON.parse(raw); } catch (e) { o = null; } }
    if (!o || typeof o !== 'object') return;
    plan.c = (o.c && byId[o.c] && byId[o.c].school) ? o.c : null;
    plan.f = (Array.isArray(o.f) ? o.f : []).filter(function (id, i, a) { return byId[id] && byId[id].school && id !== plan.c && a.indexOf(id) === i; }).slice(0, MAXF);
  }
  function storePlan() { if (!plan.c && !plan.f.length) { store.del(PKEY); return false; } return store.set(PKEY, JSON.stringify({ v: 1, c: plan.c, f: plan.f })); }
  function decMsg(msg) { var m = q('.cp-dec-msg', dlg); if (dlg.open && m) { m.textContent = ''; m.textContent = msg; } else say(msg); }
  function declare(id) {
    var it = byId[id], msg;
    if (!it || !it.school) return;
    if (plan.c === id) { plan.c = null; msg = it.name + ' is no longer your concentration.'; }
    else {
      var was = plan.c && byId[plan.c], k = plan.f.indexOf(id);
      if (k >= 0) plan.f.splice(k, 1);
      plan.c = id;
      msg = 'Declared: ' + it.name + ' is your concentration.' + (was ? ' It replaces ' + was.name + '.' : '') + (k >= 0 ? ' It is no longer a Focus.' : '');
    }
    var kept = storePlan();
    planChanged();
    decMsg(msg + (plan.c && !kept ? ' This browser can’t keep it, so save or email your plan.' : ''));
  }
  function toggleFocus(id) {
    var it = byId[id], k = plan.f.indexOf(id), msg;
    if (!it || !it.school) return;
    if (k >= 0) { plan.f.splice(k, 1); msg = it.name + ' is no longer a Focus.'; }
    else if (plan.c === id) { decMsg('Not added: ' + it.name + ' is already your concentration. Pick a different area for a Focus.'); return; }
    else if (plan.f.length >= MAXF) { decMsg('You can add up to two Focuses. Remove one to add ' + it.name + '.'); return; }
    else { plan.f.push(id); msg = 'Added ' + it.name + ' as a Focus.'; }
    storePlan();
    planChanged();
    decMsg(msg);
  }
  function removeFromPlan(b) {
    var key = b.getAttribute('data-cp-plan-rm'), slot = b.closest('.cp-plan-slot'), btns = qa('[data-cp-plan-rm]', slot), idx = btns.indexOf(b), name;
    if (key === 'c') { name = plan.c && byId[plan.c] ? byId[plan.c].name : ''; plan.c = null; }
    else { var id = key.slice(2); name = byId[id] ? byId[id].name : ''; plan.f = plan.f.filter(function (x) { return x !== id; }); }
    storePlan();
    planChanged();
    var left = qa('[data-cp-plan-rm]', slot);
    if (left.length) left[Math.min(idx, left.length - 1)].focus();
    else if (slot.getAttribute('data-ctx') === 'detail') { var d = q('[data-cp-declare]', dlg) || dTitle; d.focus(); }
    else home();
    decMsg(name + ' removed from your plan.');
  }
  function lead() { return (plan.c && byId[plan.c]) || (plan.f[0] && byId[plan.f[0]]) || null; }
  function planLine(plain) {
    var c = plan.c && byId[plan.c], parts = [(plain ? 'Concentration: ' : '<b>Concentration:</b> ') + (c ? esc(c.name) : 'not declared yet')];
    plan.f.forEach(function (id) { if (byId[id]) parts.push((plain ? 'Focus: ' : '<b>Focus:</b> ') + esc(byId[id].name)); });
    return parts.join(plain ? ' · ' : ' <span aria-hidden="true">·</span> ');
  }
  function planHTML(ctx) {
    var c = plan.c && byId[plan.c], fs = plan.f.map(function (id) { return byId[id]; }).filter(Boolean);
    if (!c && !fs.length) return '';
    function row(k, it, key) {
      return '<li><span class="cp-plan-k">' + k + '</span><span class="cp-plan-v">' + esc(it.name) + '</span><span class="cp-plan-btns">' +
        (ctx === 'page' ? '<button type="button" class="cp-btn-text" data-cp-detail="' + esc(it.id) + '">Details<span class="cp-vh"> for ' + esc(it.name) + '</span></button>' : '') +
        '<button type="button" class="cp-btn-text" data-cp-plan-rm="' + esc(key) + '">Remove<span class="cp-vh"> ' + esc(it.name) + ' as your ' + k.toLowerCase() + '</span></button></span></li>';
    }
    var off = D.offers[lead().offer], cur = current && byId[current];
    var showStart = !(ctx === 'detail' && cur && D.offers[cur.offer].href === off.href);
    var hn = ctx === 'detail' ? 'h4' : 'h3';
    var h = '<div class="cp-plan" role="region" aria-labelledby="cp-plan-h-' + ctx + '"><' + hn + ' class="cp-plan-h" id="cp-plan-h-' + ctx + '" tabindex="-1">Your plan</' + hn + '>' +
      '<p class="cp-plan-line">' + planLine(false) + '</p><ul class="cp-plan-list">' +
      (c ? row('Concentration', c, 'c') : '') + fs.map(function (f) { return row('Focus', f, 'f:' + f.id); }).join('') + '</ul>' +
      '<div class="cp-plan-actions">' +
      (showStart ? '<a class="cp-btn cp-btn-cta" href="' + esc(off.href) + '" data-cp-plan-start>' + esc(off.label) + '</a>' : '') +
      '<a class="cp-btn" href="' + esc(D.advanced.href) + '" data-cp-adv>' + esc(D.advanced.label) + '</a>' +
      '<a class="cp-btn" href="' + esc(mailHref()) + '" data-cp-plan-mail>Email my plan to EducationAI</a>' +
      '<button type="button" class="cp-btn" data-cp-plan-save>Save my plan</button></div>' +
      '<p class="cp-fine">' + (showStart ? esc(off.fine) + ' ' : '') + 'Email opens your own email app with your plan filled in, so you can read it before you send it. Your plan is kept only in this browser.</p>' +
      (ctx === 'detail' ? '' : '<p class="cp-plan-honest">' + esc(D.planHonest) + '</p>') + '<p class="cp-save-msg cp-fine" role="status" aria-live="polite"></p></div>';
    return h;
  }
  function renderPlans() {
    qa('.cp-plan-slot').forEach(function (s) { s.innerHTML = planHTML(s.getAttribute('data-ctx')); });
  }
  function syncDeclare() {
    var it = current && byId[current];
    if (it) {
      var db = q('[data-cp-declare]', dlg), fb = q('[data-cp-focus]', dlg), hint = q('.cp-dec-hint', dlg);
      if (db) { var on = plan.c === it.id; db.textContent = on ? 'Remove as my concentration' : 'Declare this concentration'; db.classList.toggle('cp-btn-cta', !on); }
      if (fb) fb.textContent = inList(plan.f, it.id) ? 'Remove this Focus' : 'Add as a Focus';
      if (hint) hint.textContent = plan.c === it.id ? 'This is your concentration. A Focus has to be a different area.'
        : (!inList(plan.f, it.id) && plan.f.length >= MAXF ? 'Your plan has two Focuses, the most it can have.' : '');
    }
    renderPlans();
  }
  function syncCards() {
    items.forEach(function (it) {
      var p = it.li && q('.cp-card-mine', it.li); if (!p) return;
      var t = plan.c === it.id ? 'Your concentration' : (inList(plan.f, it.id) ? 'Your Focus' : '');
      p.textContent = t; p.hidden = !t;
    });
  }
  function planChanged() { syncDeclare(); syncCards(); }

  /* ---------- plan text: email + download ---------- */
  function wrap(t, ind) {
    var w = 76 - ind.length, out = [], line = '';
    String(t).split(/\s+/).forEach(function (x) {
      if (!x) return;
      if (line && (line + ' ' + x).length > w) { out.push(ind + line); line = x; } else line = line ? line + ' ' + x : x;
    });
    if (line) out.push(ind + line);
    return out.join('\n');
  }
  function abs(href) {
    if (/^https?:/i.test(href)) return href;
    var base = /^https?:$/.test(location.protocol) ? location.origin : D.base;
    if (href.charAt(0) === '#') return base + '/' + href;
    return base + (href.charAt(0) === '/' ? href : '/' + href);
  }
  function mailText() {
    var c = plan.c && byId[plan.c], L = ['Hello EducationAI,', '', 'Here is the plan I made in the concentration picker.', ''];
    L.push('Concentration: ' + (c ? c.name + (c.sch ? ' (' + c.sch.name + ')' : '') : 'not declared yet'));
    plan.f.forEach(function (id) { var f = byId[id]; if (f) L.push('Focus: ' + f.name + (f.sch ? ' (' + f.sch.name + ')' : '')); });
    var l = lead();
    if (l) L.push('', 'I would start with: ' + l.starts);
    if (c && c.m) L.push('Model program: ' + c.m.name + ' (' + c.m.declared + ')');
    L.push('', 'My name:', 'My state:', 'My questions:', '', D.planHonest);
    return L.join('\r\n');
  }
  function mailHref() { return 'mailto:' + D.email + '?subject=' + encodeURIComponent('My EducationAI plan') + '&body=' + encodeURIComponent(mailText()); }
  function itemText(it, L) {
    var o = D.offers[it.offer];
    L.push(it.name.toUpperCase(), it.sch ? it.sch.name : 'Not sure yet? Start here', '');
    L.push('WHAT IT IS', wrap(it.summary, '  '), '', 'WHO IT IS FOR', wrap(it.who, '  '), '');
    L.push('HOW TO START', wrap('Starts with ' + it.starts + ' (open now).', '  '), wrap(o.plan + '.', '  '), '  ' + abs(o.href), '');
    L.push('LENGTH', wrap(it.len + ' of the program, self-paced. ' + D.lengthNote, '  '), '');
    L.push('THE PATH, IN ORDER');
    it.core.forEach(function (e, i) {
      L.push(wrap((i + 1) + '. ' + e.c + ' · ' + (e.t || title(e.c)) + ' · ' + (isOpen(e.c) ? 'OPEN NOW' : 'opening soon') + (e.r ? ' · ' + (ROLE[e.r] || e.r) : ''), '  '));
    });
    if (it.el.length) {
      L.push('', 'ELECTIVES THAT FIT');
      it.el.forEach(function (e) {
        var n = [];
        if (e.n && e.n.length) n.push('needs ' + e.n.join(' and ') + ' first');
        if (e.a && e.a.length) n.push('take alongside ' + e.a.join(' and '));
        L.push(wrap('- ' + e.c + ' · ' + (e.t || title(e.c)) + ' · ' + (isOpen(e.c) ? 'OPEN NOW' : 'opening soon') + (n.length ? ' (' + n.join('; ') + ')' : ''), '  '));
      });
    }
    L.push('', 'SUGGESTED AI TEACHERS', wrap(it.t.map(tname).join(', '), '  '), '');
    if (it.m) {
      L.push('ADVANCED PROGRAM · MODEL PROGRAM: ' + it.m.name.toUpperCase(), wrap('Certificate of Completion: ' + it.m.declared, '  '));
      it.m.terms.forEach(function (t) {
        L.push('  ' + t.t + ' · ' + t.n + (t.s ? ' (shared core)' : ''));
        t.c.forEach(function (c) { L.push(wrap('- ' + c[0] + ' · ' + (c[1] || 'shared core course'), '    ')); });
      });
      if (it.m.lic) L.push(wrap(it.m.lic, '  '));
      L.push('');
    }
  }
  function planText() {
    var L = [], rule = '------------------------------------------------------------------------', c = plan.c && byId[plan.c];
    var date; try { date = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }); } catch (e) { date = new Date().toDateString(); }
    L.push('EDUCATIONAI · MY PLAN', 'Saved ' + date + ' from the concentration picker', rule, '');
    L.push('YOUR PLAN', '  ' + planLine(true).replace(/&amp;/g, '&'), '', wrap(D.planHonest, '  '), '');
    if (c) { L.push(rule, 'CONCENTRATION', rule); itemText(c, L); }
    plan.f.forEach(function (id) {
      var f = byId[id]; if (!f) return;
      L.push(rule, 'FOCUS', rule, wrap(D.focusText, '  '), '');
      if (f.m && f.m.focus && f.m.focus.length) { L.push('FOCUS COURSES (' + f.m.name + ' model)'); f.m.focus.forEach(function (x) { L.push('  - ' + x[0] + ' · ' + x[1]); }); L.push(''); }
      itemText(f, L);
    });
    L.push(rule, 'THE ADVANCED PROGRAM', wrap(D.advanced.fine, '  '), '  ' + abs(D.advanced.href), '');
    L.push('THE FOUR-YEAR AI PROGRAM', wrap(D.program.fine, '  '), '  ' + abs(D.program.href), '');
    L.push(rule, 'PLEASE NOTE', wrap(D.note, '  '), wrap(D.fine, '  '), '');
    L.push('To tell us your plan, email ' + D.email, 'EducationAI, a Lund Studio LLC brand · ' + D.edition, '');
    return L.join('\r\n');
  }
  function download(name, text, near) {
    var blob = new Blob(['﻿' + text], { type: 'text/plain;charset=utf-8' });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { window.navigator.msSaveOrOpenBlob(blob, name); return; }
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; a.hidden = true;
    (near || root).appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(url); if (a.parentNode) a.parentNode.removeChild(a); }, 1500);
  }
  function savePlan(b) {
    if (!lead()) return;
    var name = 'educationai-my-plan.txt', slot = b.closest('.cp-plan-slot');
    download(name, planText(), slot);
    var m = q('.cp-save-msg', slot);
    if (m) m.textContent = 'Saved: ' + name + ' is in your downloads.';
  }

  /* ---------- compare ---------- */
  function mini(list, shared, core) {
    if (!list.length) return '<span class="cp-fine">None listed</span>';
    return '<ol class="cp-mini">' + list.map(function (e) {
      var s = core && shared.indexOf(e.c) >= 0;
      return '<li' + (s ? ' class="is-shared"' : '') + '><b>' + esc(e.c) + '</b> ' + esc(e.t || title(e.c)) + (isOpen(e.c) ? '<span class="cp-st cp-st-open">Open now</span>' : '') + (s ? '<span class="cp-vh"> (in every path compared)</span>' : '') + '</li>';
    }).join('') + '</ol>';
  }
  function renderCompare() {
    var its = pins.map(function (id) { return byId[id]; }).filter(Boolean);
    cTitle.textContent = its.length > 1 ? 'Compare ' + its.length + ' paths' : 'Compare paths';
    if (its.length < 2) {
      cBody.innerHTML = '<p class="cp-cmp-few">Pin at least two paths to compare them side by side. Use the Compare button on any card' + (its.length ? '; ' + esc(its[0].name) + ' is pinned now.' : '.') + '</p>';
      return;
    }
    var shared = its[0].core.map(function (e) { return e.c; }).filter(function (c) { return its.every(function (it) { return it.core.some(function (e) { return e.c === c; }); }); });
    var rows = [
      ['Who it’s for', function (it) { return esc(it.who); }],
      ['Starts with', function (it) { var o = D.offers[it.offer]; return esc(it.starts) + '<br><span class="cp-fine">' + esc(o.label.replace('Start with ', '')) + ' launch price</span>'; }],
      ['Length', function (it) { return esc(it.len) + ', self-paced'; }],
      ['The path, in order', function (it) { return mini(it.core, shared, true); }],
      ['Electives', function (it) { return mini(it.el, shared, false); }],
      ['Skill cards', function (it) { return it.cards.length ? esc(it.cards.map(function (s) { return cardParts(s)[0]; }).join(', ')) : 'None suggested yet'; }],
      ['Suggested teachers', function (it) { return esc(it.t.map(tname).join(', ')); }]
    ];
    var h = '<p class="cp-shared"><strong>In every path here:</strong> ' + (shared.length ? esc(shared.map(function (c) { return c + ' ' + title(c); }).join(' · ')) : 'no core course in common.') + '</p>';
    h += '<div class="cp-cmp-scroll"><table class="cp-table"><caption class="cp-vh">Comparing ' + esc(its.map(function (it) { return it.name; }).join(', ')) + '</caption><thead><tr><td class="cp-rowh"></td>' +
      its.map(function (it) {
        return '<th scope="col"><span class="cp-cmp-school">' + esc(it.sch ? it.sch.name : 'Not sure yet?') + '</span><span class="cp-cmp-name">' + esc(it.name) + '</span></th>';
      }).join('') + '</tr><tr class="cp-acts"><td></td>' + its.map(function (it) {
        return '<td><span class="cp-cmp-btns"><button type="button" class="cp-btn cp-btn-sm" data-cp-detail="' + esc(it.id) + '">Details<span class="cp-vh"> for ' + esc(it.name) + '</span></button>' +
          '<button type="button" class="cp-btn-text" data-cp-unpin="' + esc(it.id) + '">Remove<span class="cp-vh"> ' + esc(it.name) + '</span></button></span></td>';
      }).join('') + '</tr></thead><tbody>' +
      rows.map(function (r) { return '<tr><th scope="row" class="cp-rowh">' + r[0] + '</th>' + its.map(function (it) { return '<td>' + r[1](it) + '</td>'; }).join('') + '</tr>'; }).join('') +
      '</tbody></table></div>';
    h += '<div class="cp-stack">' + its.map(function (it) {
      return '<article class="cp-cmp-card"><span class="cp-cmp-school">' + esc(it.sch ? it.sch.name : 'Not sure yet?') + '</span><h4 class="cp-cmp-h">' + esc(it.name) + '</h4><dl>' +
        rows.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + r[1](it) + '</dd></div>'; }).join('') + '</dl><div class="cp-cmp-btns">' +
        '<button type="button" class="cp-btn cp-btn-sm" data-cp-detail="' + esc(it.id) + '">Details<span class="cp-vh"> for ' + esc(it.name) + '</span></button>' +
        '<button type="button" class="cp-btn-text" data-cp-unpin="' + esc(it.id) + '">Remove<span class="cp-vh"> ' + esc(it.name) + '</span></button></div></article>';
    }).join('') + '</div>';
    h += '<div class="cp-d-note"><p>' + esc(D.note) + '</p></div>';
    cBody.innerHTML = h;
  }

  /* ---------- start ---------- */
  loadFilters();
  syncSchool(false);
  syncOpts();
  loadPlan();
  setPanel(!!(window.matchMedia && window.matchMedia('(min-width: 48em)').matches));
  syncPins();
  planChanged();
  apply('init');
  edges();
  window.EAIConcentrations = {
    open: function (id) { if (byId[id]) openDetail(id, document.activeElement); },
    filter: function (s) { if (s === 'all' || schools[s]) setSchool(s, false); },
    search: function (t) { setQuery(String(t || ''), 'now'); },
    pinned: function () { return pins.slice(); },
    plan: function () { return { concentration: plan.c, focus: plan.f.slice() }; },
    needs: function () { return JSON.parse(JSON.stringify(state.needs)); }
  };
})();
